module.exports = __webpack_public_path__ + "static/media/ls-flower-half.07e80676.png";